import { App } from "vue";
import access from "./access";

export default (app: App<Element>) => {
  app.directive("access", access);
};
